// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__CX-GW","author":"Table_author__1WSti","authorImage":"Table_authorImage__iyQXt","unreadRow":"Table_unreadRow__JAxk-"};